import React from "react";
import HeroSection from "../components/HeroSection";
import EventGrid from "../components/EventGrid";
import"./pages.css";

export default function Home() {
    return (
      <div style={{ width: '100%', height: '100%', textAlign: 'center' }}className="app home-centered">
        <HeroSection />
    
        <section className="section">
        <h2 className="section-title">EVENTS</h2>
        <div id="events"><EventGrid /></div>
        </section>
      </div>
    );
}